import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import {
  StyledBodyCard,
  StyledButton,
  StyledButtonDownload,
  StyledButtons,
  StyledCard,
  StyledImage,
  StyledRichText,
  StyleHeading,
} from './Highlight.styled'
import { HeadingSizeEnum } from '../Heading/Heading'
import ButtonVariantEnum from '../../enums/ButtonVariant'
import { formatSizeUnits } from '../../utils/BytesToMo'
import alignmentMatcher from '../../interfaces/AligmentMatcher'
import buttonVariantMacher from '../../interfaces/ButtonVariantMacher'
import NormalizeMedia from '../../utils/NormalizeMedia'
import useCtaLink from '../../hooks/useCtaLink'
import CKEditorContent from '../CKEditorContent/CKEditorContent'
import { getBrowser, getMobileSystem } from '../../utils/UserAgentInformations'
import useMediaQuery from '../../hooks/useMediaQuery'
import { deviceMax } from '../../theme/breakpoints'
import LocationsSuccessFactor from '../../enums/LocationsSuccesFactorEnum'
import { locationHighlightButtonEvent } from '../../utils/gtmEvents'
import { ArrowRightIcon } from '../SearchPaginator/SearchPaginator.styled'

const TARGET = '_blank'

const Highlight = (props) => {
  const {
    className,
    ctaCardLabel,
    document,
    image,
    locationKey,
    textHtml,
    textAlignment,
    title,
    url,
    buttonVariant,
  } = props

  if(!image) {
    return null
  }

  let formatDescription = ''
  const isMobile = useMediaQuery(deviceMax.mobileL)
  const alignment = alignmentMatcher[textAlignment]
  const docExists = document && document.name && document.cloudinary
  const ctaExists = ctaCardLabel && url
  const browser = getBrowser()
  const mobileSystem = getMobileSystem()
  const [ctaUrl, ctaSlug] = useCtaLink(url)
  const [isMounted, setIsMounted] = useState(false)


  useEffect(() => {
    setIsMounted(true)
    return () => setIsMounted(false)
  }, [])

  if (docExists) {
    const size = formatSizeUnits(document.cloudinary[0].bytes)
    formatDescription =
      document.cloudinary[0].format.toUpperCase() + ' - ' + size
  }
  const variant =
    buttonVariant === null || buttonVariant === undefined
      ? ButtonVariantEnum.primary
      : buttonVariantMacher[buttonVariant]

  return (
    isMounted ?
      (<StyledCard className={className}>
        <StyledImage>{NormalizeMedia(image, isMobile)}</StyledImage>
        <StyledBodyCard>
          {title && <StyleHeading label={title} size={HeadingSizeEnum.h3}/>}
          {textHtml && (
            <StyledRichText $mobileSystem={mobileSystem} $browser={browser}>
              <CKEditorContent html={textHtml.content}/>
            </StyledRichText>
          )}
        </StyledBodyCard>
        {(ctaExists || docExists) && (
          <StyledButtons>
            {ctaExists && (
              <StyledButton
                to={ctaSlug}
                href={ctaUrl}
                target={TARGET}
                variant={variant}
                onClick={() => {
                  // muscle_shoals campaign
                  if(locationKey === LocationsSuccessFactor.muscle_shoals) {
                    locationHighlightButtonEvent()
                  }
                }}
              >
                {ctaCardLabel}
                <ArrowRightIcon/>
              </StyledButton>
            )}
            {docExists && (
              <StyledButtonDownload
                name={document.name}
                description={formatDescription}
                document={document}
                hasDownloadIcon={false}
              />
            )}
          </StyledButtons>
        )}
      </StyledCard>) : null
  )
}

// TODO
Highlight.propTypes = {
  className: PropTypes.string,
  ctaCardLabel: PropTypes.string,
  document: PropTypes.object,
  image: PropTypes.object.isRequired,
  slug: PropTypes.string,
  text: PropTypes.object,
  textAlignment: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  buttonVariant: PropTypes.string,
}

export default Highlight
